import { LEARN_APP, RESETS_APP, SEARCH_APP } from '../constants'

//Remove the min height 100vh on library || resets app based on which app is active
export default function updateSectionStyles(isOtherMicroFe: boolean) {
    const appIds = {
        resetsApp: RESETS_APP,
        searchApp: SEARCH_APP,
        learnApp: LEARN_APP
    }

    const minHeight = 'calc(100vh - var(--navbar-height))'

    const setAppStyle = (appId: string, style: string) => {
        const app = document.getElementById(appId)
        if (app) {
            const section = app.querySelector('section')
            if (section) {
                section.style.minHeight = style
            }
        }
    }

    const removeAppStyle = !isOtherMicroFe ? '0px' : minHeight
    const learnAppStyle = isOtherMicroFe ? '0px' : minHeight

    setAppStyle(appIds.resetsApp, removeAppStyle)
    setAppStyle(appIds.searchApp, removeAppStyle)
    setAppStyle(appIds.learnApp, learnAppStyle)
}
